<script type="text/babel">

    export default {
        methods: {
            validate(event) {
                if (this.hasDuplicate(event.target.value)) {
                    event.target.value = null;
                    event.preventDefault();
                    return false
                }
            },
            values() {
                return _.map(this.$refs.field.getElementsByClassName('vue-seq'), 'value')
                    .filter((v) => {
                        return v !== '';
                    });
            },
            hasDuplicate(value) {
                return this.values().filter((v) => v === value).length > 1;
            }
        }
    }
</script>